export default [{
  name: 'alertRestaurants',
  path: 'alertRestaurants',
  component: () => import('./AlertRestaurants.vue'),
  meta: {
    title: '警告餐厅'
  }
}]



// WEBPACK FOOTER //
// ./src/router/alert_restaurants/index.js